import { PersonaConfig } from "@technologyfromsage/persona-padlock";
import sharedConfig from "../config";
import config from "shared/config/config";

const basePersonaConfig: PersonaConfig = {
  personaOrigin: sharedConfig.oauthOrigin,
  appId: config.oauthAppId,
  clientId: config.oauthClientId,
  provider: "",
  timeoutMilliseconds: 30000,
};

export const getPersonaConfig = (provider: string): PersonaConfig => {
  return {
    ...basePersonaConfig,
    provider,
  };
};
